import { render } from "./EmailTemplateManager.vue?vue&type=template&id=5a855e6e&scoped=true"
import script from "./EmailTemplateManager.vue?vue&type=script&lang=js"
export * from "./EmailTemplateManager.vue?vue&type=script&lang=js"

import "./EmailTemplateManager.vue?vue&type=style&index=0&id=5a855e6e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a855e6e"]])

export default __exports__